<ng-template tpToolbarActions toolbarId="ribbon" slot="right">
  <a class="btn btn-primary" [routerLink]="'/customers/add'">
    <span class="material-icons">add</span>
    Add Customer
  </a>
</ng-template>

<div class="table-container">
  <table class="data-table">
    <thead>
      <th>Name</th>
      <th>Address</th>
      <th>City</th>
      <th>Postal Code</th>
      <th>Actions</th>
    </thead>
    <tbody>
      @for (customer of customers(); track customer.customer_id) {
        <tr>
          <td>{{ customer.customer_name }}</td>
          <td>{{ customer.address_line1 }}</td>
          <td>{{ customer.city }}</td>
          <td>{{ customer.postal_code }}</td>
          <td>
            <div class="row-actions">
              <a
                class="btn btn-icon"
                [routerLink]="['/customers', customer.customer_id]"
                ><span class="material-icons">edit</span></a
              >
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
